import { Power0, Expo } from 'gsap'
import AnimatedComponent from './AnimatedComponent'

class VLine extends AnimatedComponent {
  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .fromTo(
        $el.find('.entry__cover__image'),
        1.2,
        { x: '-100%' },
        { x: '0%', ease: Expo.easeInOut },
        0
      )
      .fromTo(
        $el.find('.entry__cover__image img'),
        1.2,
        { x: '100%' },
        { x: '0%', ease: Expo.easeInOut },
        0
      )
      .fromTo(
        $el.find('.entry__cover__image img'),
        0.5,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0
      )
  }
}

export default VLine



// WEBPACK FOOTER //
// ./scripts/components/EntryCover.js